export default __webpack_public_path__ + "images/uy-4c3f85c5401c3a3875eedbcd2173f43f.svg";